<template>
  <div class="quick-user">
    <a href="#" class="btn btn-icon btn-clean btn-lg w-40px h-40px" id="kt_quick_user_toggle" data-toggle="tooltip" data-placement="right" data-container="body" data-boundary="window" title="" data-original-title="User Profile">
      <span class="symbol symbol-30 symbol-lg-40">
        <span class="svg-icon svg-icon-xl">
          <inline-svg src="/media/svg/icons/General/User.svg" />
        </span>
      </span>
    </a>

    <div id="kt_quick_user" ref="kt_quick_user" class="offcanvas offcanvas-left p-10">
      
      <div class="offcanvas-header d-flex align-items-center justify-content-between pb-lg-5 pb-xs-2">
        <h3 class="font-weight-bold text-dark-75 m-0">
          {{$t("quickUser.title")}}
        </h3>
        <a href="#" class="btn btn-xs btn-icon btn-light btn-hover-primary" id="kt_quick_user_close">
          <i class="ki ki-close icon-xs text-muted"></i>
        </a>
      </div>
      
      <perfect-scrollbar class="offcanvas-content pr-5 mr-n5 scroll" style="max-height: 90vh; position: relative;">
        <div class="d-flex flex-column mt-2 symbol symbol-100 align-center justify-center">
              <v-chip
                v-if="this.$store.getters.isFreemium"
                color="orange"
                text-color="white"
              >
                Freemium
                <v-icon right>
                  mdi-star
                </v-icon>
            </v-chip>
            <img v-if="selectedAvatar" class="symbol-label mt-2" :src="selectedAvatar" alt="TMG_avatar" />
        </div>
        <div class="d-flex flex-column mt-lg-5 align-start ">
          <!-- Nom -->
          <div class="d-flex flex-row pb-2 m-top">
            <span class="text-dark-75 mr-2">{{$t("quickUser.name")}}:</span>
            <span class="text-muted">{{this.currentUser.lastname}}</span>
          </div>
          <!-- Prénom -->
          <div class="d-flex flex-row pb-2 m-top">
            <span class="text-dark-75 mr-2">{{$t("quickUser.firstname")}}:</span>
            <span class="text-muted">{{this.currentUser.firstname}}</span>
          </div>
          <!-- Email -->
          <div class="d-flex flex-row pb-2 m-top">
            <span class="text-dark-75 mr-2">{{$t("quickUser.email")}}:</span>
            <span class="text-muted">{{this.currentUser.email}}</span>
          </div>
          <div v-if="this.currentUser.client && !this.$store.getters.isFreemium" class="d-flex flex-row pb-lg-5 m-top">
            <span class="text-dark-75 mr-2">{{$t("quickUser.client")}}:</span>
            <span class="text-muted">{{this.currentUser.client.name}}</span>
          </div>
        </div>
        <div class="d-flex flex-column pt-lg-4 m-top">
          <div class="pb-lg-2 m-top">
            <div class="text-dark-75 mr-2">{{$t("quickUser.toolList")}}:</div>
          </div>
          <div v-if="this.currentUser.userRight">
            <ul style="list-style:inside" v-for="item in themes" :key="item.id">
              <li>{{item.title}}</li>
            </ul>
          </div>
          <div v-else class="text-muted">{{$t("quickUser.noToolFound")}}</div>

          <ForgotFormQuickUser :title="$t('quickUser.initializeMdp')" :sub-title="$t('quickUser.emailText')"/>

          <a v-if="this.$store.getters.isSuperUser && !this.$store.getters.isAdmin " class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-4 my-3" v-bind:href="'mailto:'+this.emailAdmin">{{$t("quickUser.contactUs")}}</a>

          <button class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-4 my-3" @click="onLogout">
            {{$t("quickUser.logout")}}
          </button>
        </div>
        <!--end::Header-->
        <div class="separator separator-dashed mt-lg-8 mb-lg-5"></div>
      </perfect-scrollbar>
      <!--end::Content-->
    </div>
  </div>
</template>

<style lang="scss" scoped>
  #kt_quick_user {
    overflow: hidden;
  }
  @media (max-width: 600px){
    .mobile-custom{
      display: flex;
      flex-direction: column;
      margin-top: 6px;
    }
    .mobile-custom-2{
      display: flex !important;
      flex-direction: column !important;
    }
    .m-top{
      margin-top: 5px;
    }
    /* .quick-user #kt_login_forgot_form {
      margin-top: 0.5rem !important;
    } */
  }
</style>

<script>
import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js";
import KTOffcanvas from "@/assets/js/components/offcanvas.js";
import { mapGetters } from "vuex";
import Api from "@/core/services/api.service";
import userParentThemes from "@/core/utils/userParentThemes";
import ForgotFormQuickUser from "@/components/auth/forgotFormQuickUser";
export default {
  name: "KTQuickUser",
  components: { ForgotFormQuickUser },
  data() {
    return {
      users: [],
      emailAdmin: "scharlot@boscotechnologies.fr",
      themes: [],
      avatars: [
        "/media/svg/avatars/v1.jpg",
        "/media/svg/avatars/v2.jpg",
        "/media/svg/avatars/v3.jpg",
        "/media/svg/avatars/v4.jpg",
        "/media/svg/avatars/v5.jpg",
        "/media/svg/avatars/v6.jpg",
        "/media/svg/avatars/v7.jpg",
      ],
      selectedAvatar: null,
    };
  },
  props:{
    user: Array,
  },
  mounted() {
    // Init Quick User Panel
    KTLayoutQuickUser.init(this.$refs["kt_quick_user"]);
    Api.get("themes").then(themes => (
      this.themes = userParentThemes(themes.data["hydra:member"])
      )
    );
  },
  methods: {
    onLogout() {
      this.$router.push({ name: "logout" });
    },
    closeOffcanvas() {
      new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
    },
    randomItem (items) {
      return items[Math.floor(Math.random()*items.length)];
    }
  },

  created() {
    this.selectedAvatar = this.randomItem(this.avatars)
  },

  computed: {
    ...mapGetters([
      "currentUser",
    ]),
    picture() {
      return process.env.BASE_URL + "media/users/300_21.jpg";
    }
  }
};
</script>
